import { render, staticRenderFns } from "./chinesePreview.vue?vue&type=template&id=7bae6d2e&scoped=true&"
import script from "./chinesePreview.vue?vue&type=script&lang=js&"
export * from "./chinesePreview.vue?vue&type=script&lang=js&"
import style0 from "./chinesePreview.vue?vue&type=style&index=0&id=7bae6d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae6d2e",
  null
  
)

export default component.exports